export const frameworkLicencee = {
    organizationName: 'IoT Ventures',

}